// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDefaultState as getDebitDefaultState} from '@deere/cps-it.warranty-model-factory/lib/debit';
import {postDebit} from '../../shared/repositories';
import {readAuditRecords} from './get-audit-records';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateFullDebitModalVisibility} from './full-debit-modal';

export const submitFullDebit = (debit, auditNumber) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postDebit(debit);

            updateFullDebitModalVisibility(false)(dispatch);

            dispatch({
                debit: getDebitDefaultState(),
                type: actions.RESET_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM
            });

            successAlertBar(translate('DEBIT_SUBMITTED_SUCCESSFULLY'));

            readAuditRecords(auditNumber)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/action-creators/submit-full-debit.js